var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { HttpMethod } from '../types/enums/http-method.enum';
import axios from 'axios';
/**
 * Service to make all Axios-related calls
 */
export class AxiosService {
    constructor() {
        /**
         * Isolated axios instance
         * @protected
         */
        this.instance = axios.create();
        /** Headers for all Axios requests. */
        this.globalHeaders = {};
    }
    /**
     * Set headers for all axios requests
     */
    setGlobalHeaders(headers) {
        this.globalHeaders = Object.assign(Object.assign({}, this.globalHeaders), headers);
    }
    all(values) {
        return __awaiter(this, void 0, void 0, function* () {
            return axios.all(values);
        });
    }
    delete(url, config) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.request(Object.assign({ url, method: HttpMethod.DELETE }, config));
        });
    }
    get(url, config) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.request(Object.assign({ url, method: HttpMethod.GET }, config));
        });
    }
    post(url, data, config) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.request(Object.assign({ url, method: HttpMethod.POST, data }, config));
        });
    }
    put(url, data, config) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.request(Object.assign({ url,
                data, method: HttpMethod.PUT }, config));
        });
    }
    request(config) {
        return __awaiter(this, void 0, void 0, function* () {
            const headers = Object.assign(Object.assign({}, this.globalHeaders), config.headers);
            return this.instance(Object.assign(Object.assign({}, config), { headers: Object.keys(headers).length ? headers : undefined }));
        });
    }
    /**
     * Sets the XHR worker to be used for all XHR requests performed by this service.
     */
    setXhrWorker(xhrWorker) {
        this.instance = xhrWorker;
    }
}
// Exporting as singleton service
export const axiosService = new AxiosService();
